import angular from 'angular';
import uiRouter from 'angular-ui-router';
import ngMaterial from 'angular-material';
import theme from './theme';
var MainController = /** @class */ (function () {
    function MainController($rootScope, $scope, seoMetaService) {
        'ngInject';
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.seoMetaService = seoMetaService;
        this.seoMetaService.updateSeoMetaData(this, 'MainController');
    }
    MainController.prototype.$onInit = function () {
        var _this = this;
        this.$rootScope.$on('hero-loaded', function () {
            _this.showSecondaryContent = true;
        });
    };
    return MainController;
}());
export { MainController };
export default angular.module('eeComUiApp.main', [uiRouter, ngMaterial, theme])
    .controller('MainController', MainController)
    .component('main', {
    template: require('./main.html'),
    controller: 'MainController'
})
    .name;
//# sourceMappingURL=main.component.js.map